<template>
  <v-footer inset flat elevation="0" class=" white mt-10 ma-0">
    <v-col
      cols="12"
      class="overline caption-md "
      style="text-align:center !important"
      >Copyright {{ new Date().getFullYear() }} — Created by
      <a
        href="https://www.vindico.net/"
        target="_blank"
        style="color: var(--v-primary-base) !important; text-decoration: none;"
        ><b>Vindico</b></a
      >
      &copy; |
      <span
        style="cursor:pointer !important; color: var(--v-primary-base) !important; text-decoration: none;"
        v-on:click="dialog = true"
        >Privacy and Terms & Conditions</span
      >
      |v1.026</v-col
    >
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          Privacy and Terms & Conditions
          <v-spacer></v-spacer>

          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-toolbar>

      <PrivacyTermsConditions/>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">
            Read
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-footer>
</template>

<script>
import PrivacyTermsConditions from "../page-components/PrivacyTermsConditions";

export default {
  name: "Footer",
  components: {
    PrivacyTermsConditions
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {},
  methods: {},
};
</script>
